import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { blockConfig } from '../../../config';

const BlockTravelWrapper = styled.div`
  height: 100%;
  width: 100%;
  background: ${p => p.color ? p.color : blockConfig.alert.none.colorTravel};
  ${p => p.isTo ?
    `
  border-top-left-radius: ${blockConfig.radius}px;
  border-bottom-left-radius: ${blockConfig.radius}px;
  ` :
    `
  border-top-right-radius: ${blockConfig.radius}px;
  border-bottom-right-radius: ${blockConfig.radius}px;
  `
}
`;

const BlockTravel = ({ color, isTo }) => <BlockTravelWrapper color={color} isTo={isTo} />;

BlockTravel.propTypes = {
  color: PropTypes.string,
  isTo: PropTypes.bool,
};

export default React.memo(BlockTravel);
